import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '../../../../components/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSignalsList } from '../../../../stores/signals-main/signals/actions';
import { getSignalsPaging } from '../../../../stores/signals-main/signals/getters';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getActiveSignalsTableTab } from './Tabs/TabItem';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'var(--color-white)',
  },
}));

export function getSignalsPaginationPageNo() {
  const params = new URLSearchParams(document.location.search);
  const page = params.get('page');

  return page || '1';
}

export function useSignalsPaginationPageNo() {
  return getSignalsPaginationPageNo();
}

const SignalsPagination = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const prev = useSelector((state) => {
    const { prev = null } = getSignalsPaging(state);

    return prev;
  });

  const next = useSelector((state) => {
    const { next = null } = getSignalsPaging(state);

    return next;
  });

  async function onPaginationChange(pageNo) {
    try {
      const activeTab = getActiveSignalsTableTab();
      await dispatch(fetchSignalsList(activeTab, pageNo));
      history.push(`?tab=${activeTab}&page=${pageNo}`);
    } catch (e) {
      console.log(e);
    }
  }

  if (!prev && !next) {
    return <></>;
  }

  return (
    <div className={classes.root}>
      <Pagination
        onPaginationChange={onPaginationChange}
        prev={prev}
        next={next}
      />
    </div>
  );
};

export default SignalsPagination;
